// Url PATH

export const BASE_URL = "https://atsback.bartechdatasystems.co.in";
// export const BASE_URL = "http://localhost:8000";

